import React from "react";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import RoutesApp from "./routes";
import { AuthProvider } from "./contexts/auth";
import theme from "./theme";

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <AuthProvider>
      <RoutesApp />
    </AuthProvider>
  </ThemeProvider>
);

export default App;